import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import Spinner from '../layout/Spinner';
import Topbar from '../layout/Topbar';
import { getUtenti } from '../../actions/auth';

const GestioneUtenti = ({ auth: { user, utenti, loading }, getUtenti }) => {

  const [utentiData, setUtentiData] = useState([]);
  const [testoCerca, setTestoCerca] = useState('');

  const onChangeFiltraUtenti = (testo) => {
    setTestoCerca(testo);
    let arrayUtenti = [...utenti];
    if (testo) {
      arrayUtenti = arrayUtenti.filter(el =>
        el.username.toLowerCase().includes(testo.toLowerCase()) ||
        el.email.toLowerCase().includes(testo.toLowerCase()) 
      );
    }
    setUtentiData(arrayUtenti);
  };

  useEffect(() => {
    getUtenti();
  }, [getUtenti]);

  useEffect(() => {
    setUtentiData(utenti);
  }, [utenti]);

  if (user && user.ruolo !== 'admin') {
    return <Redirect to="/gestione-magazzino" />;
  }

  return (loading ? <Spinner /> :
    <div className="section lightblue user-block wf-section">
      <Topbar
        labelPagina={"Gestione utenti"}
        isFolder={false}
      />
      <div className="w100">
        <div className="margin mt0">
          <div className="esterni gestione">
            <form action="/search" className="search w-form">
              <input type="search" className="search-input w-input" maxLength="256" name="query" placeholder="Cerca utente" id="search-2" value={testoCerca} onChange={(e) => onChangeFiltraUtenti(e.target.value)} />
              <input disabled type="submit" value="Cerca" className="search-btn w-button" />
            </form>
            <a href="/aggiungi-utente" className="button-small w-button">Aggiungi utente</a>
          </div>
          <div className="colonne">
            <div className="w100">
              <div className="list-gestione">
                <div className="wide-responsive">
                  <div className="w-layout-grid utenti-grid-indice">
                    <div id="w-node-_2fd5e7d5-4fc4-3674-b272-0bf7d9751f47-f503dc95">
                      <p>username</p>
                    </div>
                    <div id="w-node-_2fd5e7d5-4fc4-3674-b272-0bf7d9751f47-f503dc95">
                      <p>email</p>
                    </div>
                    <div id="w-node-_2fd5e7d5-4fc4-3674-b272-0bf7d9751f47-f503dc95">
                      <p>ruolo</p>
                    </div>
                    <div id="w-node-_2fd5e7d5-4fc4-3674-b272-0bf7d9751f47-f503dc95">
                      <p></p>
                    </div>
                  </div>
                  <div>
                    {utentiData.map((el) => (
                      <div key={el._id} className="w-layout-grid utenti-grid">
                        <div><p>{el.username}</p></div>
                        <div><p>{el.email}</p></div>
                        <div><p>{el.ruolo}</p></div>
                        <div>
                          <a className="item-grid w-inline-block bottone_azione" href={`modifica-utente/${el._id}`}>
                            <div className="adiacenti">
                              <p>Modifica</p>
                              <img src="assets/media/edit-icon.png" loading="lazy" alt="" className="icon" />
                            </div>
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="w-layout-grid utenti-grid-indice">
                    <div id="w-node-_2fd5e7d5-4fc4-3674-b272-0bf7d9751f47-f503dc95">
                      <p>username</p>
                    </div>
                    <div id="w-node-_2fd5e7d5-4fc4-3674-b272-0bf7d9751f47-f503dc95">
                      <p>email</p>
                    </div>
                    <div id="w-node-_2fd5e7d5-4fc4-3674-b272-0bf7d9751f47-f503dc95">
                      <p>ruolo</p>
                    </div>
                    <div id="w-node-_2fd5e7d5-4fc4-3674-b272-0bf7d9751f47-f503dc95">
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

GestioneUtenti.propTypes = {
  auth: PropTypes.object.isRequired,
  getUtenti: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, { getUtenti })(GestioneUtenti);
